// extracted by mini-css-extract-plugin
export default {"PopularButton":"PopularButton_PopularButton__OLDF4"};